<template>
  <tr>
    <td>{{ index + 1 }}</td>
    <td>{{ item.category }}</td>
    <td>{{ item.parent.title }}</td>
    <td>{{ item.title }}</td>
    <td style="width: 7vw;">
      <input v-model="power" type="number" step="0.01" class="form-control" @input="updateItem" />
    </td>
    <td style="width: 7vw;">
      <input v-model="responsibility" type="number" step="0.01" class="form-control" @input="updateItem" />
    </td>
    <td style="width: 7vw;">
      <input v-model="urgency" type="number" step="0.01" class="form-control" @input="updateItem" />
    </td>
  </tr>
</template>

<script>
export default {
  name: "BeneficiaryRowMitchell",
  props: {
    item: Object,
    index: Number,
  },
  data() {
    return {
      power: this.item.mitchell_beneficiary_many?.[0]?.power ?? '',
      responsibility: this.item.mitchell_beneficiary_many?.[0]?.responsibility ?? '',
      urgency: this.item.mitchell_beneficiary_many?.[0]?.urgency ?? '',
    };
  },
  methods: {
    updateItem() {
      this.validateAndEmit('power');
      this.validateAndEmit('responsibility');
      this.validateAndEmit('urgency');
    },
    validateAndEmit(field) {
      if (this[field] !== '') {
        this[field] = Math.min(5, Math.max(1, parseFloat(this[field])));
      }
      this.$emit('update', {
        id: this.item.id,
        power: parseFloat(this.power) || 0,
        responsibility: parseFloat(this.responsibility) || 0,
        urgency: parseFloat(this.urgency) || 0,
      });
    },
  },
  mounted() {
    this.updateItem();
  },
};
</script>

<style scoped>
input {
  text-align: center;
}
</style>
